import PropTypes from 'prop-types';
import {
  Box,
  Button, Divider, Icon,
  Typography,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import {useTranslation} from 'react-i18next';
import {createPlayer} from '../utils/PlayerApi';
import {useLoading} from '../../loading-overlay/LoadingContext';
import {Check, NotInterested} from '@mui/icons-material';

export default function ReviewDataPageStep({nextStep, previousStep, workFlowData}) {
  const {t} = useTranslation();
  const {addToLoading} = useLoading();

  async function onSubmit(e) {
    e.preventDefault();

    const response = await addToLoading(createPlayer(workFlowData));
    if (response.status === 200) {
      nextStep();
    }
  }

  function goBack() {
    previousStep();
  }

  return (
    <div>
      <Typography variant="h2" gutterBottom marked="center" align="center">
        {t('review-data-page-title')}
      </Typography>
      <Box component="form" onSubmit={onSubmit} sx={{mt: 6}}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box>
              <Typography>
                {t('review-data-accept-text',
                  {firstName: workFlowData.firstName, lastName: workFlowData.lastName})}
              </Typography>
              <Divider/>
              <Typography variant="h6">{t('email')}</Typography>
              <Typography>
                {workFlowData.email ? workFlowData.email : t('email-missing')}
              </Typography>
              <Divider />
              <Typography variant="h6">{t('newsletter')}</Typography>
              <Icon> { workFlowData.wantsNewslettersEmails ? <Check/> : <NotInterested/> } </Icon>
              <Divider/>
              <Typography variant="h6">{t('gender.label')}</Typography>
              <Typography>{t(`gender.${workFlowData.gender}`)}</Typography>
              <Divider/>
              <Typography variant="h6">{t('date-of-birth')}</Typography>
              <Typography>{workFlowData.dateOfBirth.format('LL')}</Typography>
              <Divider/>
              <Typography variant="h6">{t('display-name-label')}</Typography>
              <Typography>{workFlowData.displayName}</Typography>
              <Divider/>
            </Box>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <Button
              onClick={goBack}
              fullWidth
            >
              {t('back-button')}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              type="submit"
              fullWidth
            >
              {t('confirm-button')}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
ReviewDataPageStep.propTypes = {
  nextStep: PropTypes.func.isRequired,
  previousStep: PropTypes.func.isRequired,
  workFlowData: PropTypes.any.isRequired,
};
